import web2dList1 from './web2d-list/4c5eee5ad3ca4eb5b7cef811718a547e.json';
import web2dList2 from './web2d-list/9dc96b6616a6412eb87178cb4a67d71e.json';
import web2dList3 from './web2d-list/c68828fbe82e4b26b52d8ba1068feccb.json';

import web3d1 from './web3d/15eb4f5e0e51448c8799806e69d38e8b.json';
import web3d2 from './web3d/81b476f0b0d54a62968b1dee40430130.json';
import web3d3 from './web3d/1774bd13a1b84a369d1ec76c1d5487a3.json';
import web3d4 from './web3d/58581cab7a524136b03f284647a8a666.json';
import web3d5 from './web3d/db47f41e93f34639928d3fb74ce0ed63.json';
import web3d6 from './web3d/de2888d3a3ef4ca999d6a4de0f399061.json';
import web3d7 from './web3d/f5d0257d25884520abf034b0889424a9.json';

import web2d1 from './web2d/2ebfd0a2ac074143b141165749e6fd58.json';
import web2d2 from './web2d/8b80ab35f821413f93a66a0921fb423c.json';
import web2d3 from './web2d/7249f2ba99f14c91918b542f64388419.json';

export default {
  '4c5eee5ad3ca4eb5b7cef811718a547e': web2dList1,
  '9dc96b6616a6412eb87178cb4a67d71e': web2dList2,
  'c68828fbe82e4b26b52d8ba1068feccb': web2dList3,
};

export const web3dData = {
  '15eb4f5e0e51448c8799806e69d38e8b': web3d1,
  '81b476f0b0d54a62968b1dee40430130': web3d2,
  '1774bd13a1b84a369d1ec76c1d5487a3': web3d3,
  '58581cab7a524136b03f284647a8a666': web3d4,
  'db47f41e93f34639928d3fb74ce0ed63': web3d5,
  'de2888d3a3ef4ca999d6a4de0f399061': web3d6,
  'f5d0257d25884520abf034b0889424a9': web3d7,
};

export const web2dData = {
  '2ebfd0a2ac074143b141165749e6fd58': web2d1,
  '8b80ab35f821413f93a66a0921fb423c': web2d2,
  '7249f2ba99f14c91918b542f64388419': web2d3,
};